import { Fade } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import theme from '../../assets/styles/theme';

export function FadeInComponent({ children, scrollPosition }: any) {
  const animRef = useRef<HTMLDivElement | null>(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    isWithinView(animRef, setAnimate, window.innerHeight * 0.7);
  }, [scrollPosition]);

  function isWithinView(ref: any, setShow: Function, range: number) {
    try {
      if (!ref && !ref.current) return;
      if (ref && ref !== null && ref.current && ref.current !== null) {
        const { top } = ref.current.getBoundingClientRect();

        console.log(top, range);

        if (top < range) setShow(true);
      } else {
        return;
      }
    } catch (error) {}
  }
  return (
    <div
      ref={animRef}
      style={{ width: '100%', justifyContent: 'center', display: 'flex' }}
    >
      <Fade
        in={animate}
        easing={{ enter: theme.transitions.easing.easeInOut }}
        timeout={500}
      >
        {children}
      </Fade>
    </div>
  );
}
